<template>
    <div class="addBox">
        <div class="add" @click="$router.push(path)">
            <img src="~@img/xueyezixun/consultant/student/student_add.png" alt="" />
            <p style="text-align: center">{{name}}<span :style="{display:path?'':'none'}">添加</span></p>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Add",
        props:['name','path']
    }
</script>

<style scoped lang="less">
.addBox {
    padding-top: 80px;
    display: flex;
    justify-content: center;
    .add {
        cursor: pointer;
        img {
            margin-bottom: 20px;
            display: block;
            margin: 0 auto;
        }
        p {
            line-height: 30px;
            font-size: 16px;
            span {
                color: #2BA6EE;
                cursor: pointer;
            }
        }
    }
}
</style>